import React, {useState} from 'react';
import moment from 'moment';
import cx from 'classnames';
import Message from '../../../components/common/Message';
import PayoutReportDetail from './PayoutReportListItemDetail';
import {Icon, svgs} from 'epic-diesel-common/src';
import {PaymentStatus} from '../../../../shared/types';
import {transformAmount, getPaymentStatusCode} from '../../../utils/PayoutUtils';
import {ReportListItem} from '../../../reducers/payout';

//@ts-ignore
import styles from './PayoutReport.pcss';

export interface PayoutReportListItemProps {
    item: ReportListItem;
    getPayoutReportDetail: (data) => void;
    loadingDetail?: boolean;
}

const PayoutReportListItem: React.FC<PayoutReportListItemProps> = ({
    item: {status, paymentCreateDate, reportDetailInfo, paymentId, amount, notes},
    getPayoutReportDetail,
    loadingDetail
}) => {
    const [expanded, setExpanded] = useState(false);
    const date = moment(paymentCreateDate).format('YYYY-MM');

    const arrowClass = cx(styles.arrowIcon, {
        [styles.isExpanded]: expanded
    });

    const statusClass = cx({
        [styles.warning]: status === PaymentStatus.IN_PROGRESS,
        [styles.error]: status === PaymentStatus.FAILED,
        [styles.complete]: status === PaymentStatus.COMPLETED
    });

    function handleClickExpand() {
        if (!expanded && !reportDetailInfo && !loadingDetail) {
            getPayoutReportDetail({paymentId});
        }
        setExpanded(!expanded);
    }

    return (
        <>
            <div className={expanded ? styles.payoutReportExpanded : ''}>
                <p>
                    <span className={statusClass}>
                        <Message code={getPaymentStatusCode(status)} />
                    </span>
                </p>
                <p>{notes}</p>
                <p>{date}</p>
                <p>{transformAmount(amount)}</p>
                <button onClick={handleClickExpand} className={styles.action}>
                    <Icon icon={svgs.CHEVRON_DOWN} className={arrowClass} />
                </button>
            </div>
            <PayoutReportDetail reportDetailInfo={reportDetailInfo} expanded={expanded} />
        </>
    );
};

export default PayoutReportListItem;
